module.exports = __webpack_public_path__ + "static/A01-9ae6ad3fba11a99e6352687ed0b14bdf.jpg";